import { Controller } from '@hotwired/stimulus';

// Bootstrap 3 の CSS のまま、jQuery の Bootstrap プラグインと同じクラスを付け外しして開閉する
export default class extends Controller {
  // action="collapse#toggle"
  toggle(event) {
    event.preventDefault();
    const target = document.querySelector(this.element.getAttribute('href'));
    const opening = !target.classList.contains('in');

    target.classList.toggle('in', opening);
    target.setAttribute('aria-expanded', String(opening));
    this.element.classList.toggle('collapsed', !opening);
    this.element.setAttribute('aria-expanded', String(opening));
  }
}
